var CONTACT_METHOD_OPTIONS = [{
  value: 'CALL_SMS_EMAIL',
  label: 'Call/ SMS/ Email'
}, {
  value: 'SKYPE',
  label: 'Skype'
}, {
  value: 'WHATSAPP',
  label: 'WhatsApp'
}, {
  value: 'WECHAT',
  label: 'WeChat'
}, {
  value: 'TELEGRAM',
  label: 'Telegram'
}];
var CONTACT_METHOD_MAPPER = {
  WHATSAPP: 'WhatsApp Number',
  WECHAT: 'WeChat Number',
  TELEGRAM: 'Telegram Number',
  SKYPE: 'Skype Number'
};
var NUMBER_OF_STUDENTS_OPTIONS = [{
  value: '1_5',
  label: '1-5'
}, {
  value: '6_20',
  label: '6-20'
}, {
  value: '21_50',
  label: '21-50'
}, {
  value: '51_250',
  label: '51-250'
}, {
  value: '251',
  label: '251+'
}];
var SERVICES_OPTIONS = [{
  value: 'IELTS_TOEFL_COACHING',
  label: 'IELTS/ TOEFL Coaching'
}, {
  value: 'COUNSELLING_AND_APPLICATION_PROCESSING',
  label: 'Counselling and Application Processing'
}, {
  value: 'VISA_APPLICATION',
  label: 'Visa Application'
}, {
  value: 'SOP_AND_INTERVIEW_PREP',
  label: 'SoP and Interview Preparation'
}, {
  value: 'PRE_AND_POST_LANDING_SERVICES',
  label: 'Pre and Post Landing Services'
}];
var HOW_DID_YOU_FIND_US_OPTIONS = [{
  value: 'SOCIAL_MEDIA_PLATFORM',
  label: 'Social Media Platform'
}, {
  value: 'LINKEDIN',
  label: 'LinkedIn'
}, {
  value: 'WORD_OF_MOUTH',
  label: 'Word Of Mouth'
}, {
  value: 'THROUGH_A_STUDENT',
  label: 'Through A Student'
}, {
  value: 'APPLYBOARD_APPROACHED_ME',
  label: 'ApplyBoard Approached Me'
}];
var MARKETING_METHODS_OPTIONS = [{
  value: 'FAIRS_WORKSHOPS_SEMINARS',
  label: 'Education Fairs, Workshops And Seminars'
}, {
  value: 'NEWSPAPERS_MAGAZINES_PAMPHLET',
  label: 'Newspapers, Magazines And Pamphlet Advertisement'
}, {
  value: 'ONLINE_ADS',
  label: 'Facebook, Instagram And Google Ads'
}, {
  value: 'B2B_AGENT_NETWORKS',
  label: 'B2B Agent Networks'
}, {
  value: 'OTHER',
  label: 'Other'
}];
var AVERAGE_SERVICE_FEE_OPTIONS = [{
  value: '0_200',
  label: '$0 - $200'
}, {
  value: '200_500',
  label: '$200 - $500'
}, {
  value: '500_1000',
  label: '$500 - $1000'
}, {
  value: '1000_2500',
  label: '$1000 - $2500'
}, {
  value: '2500',
  label: '$2500 +'
}];
var WHY_APPLYBOARD_OPTIONS = [{
  value: 'MORE_STUDENTS',
  label: 'Covers More Schools Globally'
}, {
  value: 'UNIFIED_PLATFORM',
  label: 'Unified Platform For All Needs'
}, {
  value: 'TRANSPARENT_FASTER_PAYMENT',
  label: 'Transparent And Faster Payments'
}, {
  value: 'INDUSTRY_INSIGHTS_TRAINING',
  label: 'Better Industry Insights And Training'
}, {
  value: 'OTHER',
  label: 'Other'
}];
var HOW_HELP_GROW_BUSINESS_OPTIONS = [{
  value: 'MORE_STUDENTS',
  label: 'Bring More Student Leads To My Business'
}, {
  value: 'MANAGE_OFFICE_EMPLOYEES',
  label: 'Help Me Manage My Offices And Employees'
}, {
  value: 'INDUSTRY_NEWS',
  label: 'Keep Me Updated On Industry News'
}, {
  value: 'SOP_REVIEW_POST_LANDING_SERVICE',
  label: 'Provide Services Such As SoP Review, Pre And Post Landing Services'
}, {
  value: 'DESTINATION_SPECIFIC_TRAINING',
  label: 'Provide Destination Specific Training'
}];
var WEB_URL_VALIDATION_REGEX = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
var DEFAULT_MAX_INPUT_LENGTH = 120;
var AVERAGE_YEARS_OF_WORKING = 60;

// First and last name validation on monolith side require these characters to not be present.
// The regex is a bit unreadable due to the escaping.
// This is making sure the string doesn't contain any of [&<>@:~#%^*$\\{}|=]
var CHARACTER_BLACKLIST_REGEX_FOR_MANAGE_STAFF = /[!@#$%^&*()+\=\[\]{};:"\\|,<>\/?]/; // eslint-disable-line no-useless-escape
export var CHARACTER_BLACKLIST_REGEX = /^[^\[\&\<\>\@\:\~\#\%\^\*\$\\\{\}\|\=\]]*$/; // eslint-disable-line no-useless-escape

export var RP_REGISTRATION_DATA = {
  CONTACT_METHOD_OPTIONS: CONTACT_METHOD_OPTIONS,
  CONTACT_METHOD_MAPPER: CONTACT_METHOD_MAPPER,
  NUMBER_OF_STUDENTS_OPTIONS: NUMBER_OF_STUDENTS_OPTIONS,
  SERVICES_OPTIONS: SERVICES_OPTIONS,
  HOW_DID_YOU_FIND_US_OPTIONS: HOW_DID_YOU_FIND_US_OPTIONS,
  MARKETING_METHODS_OPTIONS: MARKETING_METHODS_OPTIONS,
  AVERAGE_SERVICE_FEE_OPTIONS: AVERAGE_SERVICE_FEE_OPTIONS,
  WHY_APPLYBOARD_OPTIONS: WHY_APPLYBOARD_OPTIONS,
  HOW_HELP_GROW_BUSINESS_OPTIONS: HOW_HELP_GROW_BUSINESS_OPTIONS,
  WEB_URL_VALIDATION_REGEX: WEB_URL_VALIDATION_REGEX,
  DEFAULT_MAX_INPUT_LENGTH: DEFAULT_MAX_INPUT_LENGTH,
  AVERAGE_YEARS_OF_WORKING: AVERAGE_YEARS_OF_WORKING,
  CHARACTER_BLACKLIST_REGEX: CHARACTER_BLACKLIST_REGEX,
  CHARACTER_BLACKLIST_REGEX_FOR_MANAGE_STAFF: CHARACTER_BLACKLIST_REGEX_FOR_MANAGE_STAFF
};